// JsFromRoutes CacheKey e7f9dbd518520e506ea3da6768e0e7a7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  edit: /* #__PURE__ */ definePathHelper('get', '/employers/pay_schedules/edit'),
  index: /* #__PURE__ */ definePathHelper('get', '/employers/pay_schedules'),
}
